import { Link, useLocation, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { ARTICLES, formatArticleDate } from "@/data/articles";
import NotFound from "@/pages/NotFound";
import "@/components/articles/articles.css";

export default function ArticleDetail() {
  const { slug } = useParams();
  const { state } = useLocation();
  const article = ARTICLES.find((item) => item.slug === slug && item.status === "published");
  if (!article) return <NotFound />;

  return (
    <article className="insight-detail container-x" data-testid="article-detail-page">
      <Link to={state?.from || "/articles"} className="link-arrow" data-testid="article-back-link"><ArrowLeft size={16} /> All articles</Link>
      <header className="insight-detail-header">
        <p className="insight-detail-category" data-testid="article-detail-category">{article.category}</p>
        <h1 className="t-h1" data-testid="article-detail-heading">{article.title}</h1>
        <p className="t-lead" data-testid="article-detail-excerpt">{article.excerpt}</p>
        <p className="insight-detail-meta" data-testid="article-detail-meta">{article.author}<span aria-hidden="true">·</span><time dateTime={article.publishedAt}>{formatArticleDate(article.publishedAt)}</time></p>
      </header>
      <img className="insight-detail-image" src={article.image} alt={article.imageAlt} style={{ objectPosition: article.imagePosition }} width="1200" height="675" data-testid="article-detail-image" />
      <div className="insight-detail-body" data-testid="article-detail-body">
        {article.sections.map((section, index) => (
          <section key={section.heading} data-testid={`article-detail-section-${index}`}>
            <h2 className="t-h5">{section.heading}</h2><p className="t-body">{section.text}</p>
          </section>
        ))}
        <p className="insight-disclaimer" data-testid="article-placeholder-notice">Illustrative editorial content. For general information only; not investment advice.</p>
      </div>
    </article>
  );
}